
import { Options, Vue } from 'vue-class-component'
import theNewsCategory from '@/components/Frontend/News-Category/index.vue'

@Options({
  components: {
    theNewsCategory
  }
})
export default class NewsCategory extends Vue {}
